/*
 * @Author: cc
 * @Date: 2020-11-13 14:21:06
 * @LastEditTime: 2020-11-13 17:45:29
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\weixin\service\foregoingPreview\preview.js
 * @Description: 微信渠道以前的预览框（待编、待审使用）
 */

'use strict';
angular.module('weixinServiceModule').controller('wxForegoingPreviewController', ['$scope', '$state', 'draftParams', '$modalInstance', 'trsHttpService', '$q', 'modalDialog', 'trsspliceString', 'wechatBtnService',
    function($scope, $state, draftParams, $modalInstance, trsHttpService, $q, modalDialog, trsspliceString, wechatBtnService) {
        initStatus();
        initData();

        /**
         * [initStatus description]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = {
                massArray: draftParams.items,
                type: draftParams.type,
                sendTo: '全部',
                sendWxName: draftParams.type === 'detail' ? draftParams.items.TOUSER : '',
                accounts: [], // 已经预览过的账号
                picWordId: draftParams.picWordId || '',
            };
            $scope.status = {
                isSort: false,
                showTipContent: false,
                confirmOnce: false,
            };
        }

        /**
         * [getPreviewAccounts description] 获取已经预览过的微信账号集合
         * @return  {[type]}  [return description]
         */
        $scope.getPreviewAccounts = function() {
            var params = {
                serviceid: 'mlf_wechatpreviewaccountlog',
                methodname: 'getWeChatPreviewAccountLogs',
                ChannelId: $state.params.wxchannelid,
            };
            return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => angular.isArray(data) ? data : data.DATA);
        };

        /**
         * [initData description]
         * @return {[type]} [description]
         */
        function initData() {
            if (draftParams.type === 'detail') {
                findDocDetails($scope.data.massArray).then(function() {
                    queryCoverPic();
                });
            }
            if ($scope.data.type !== 'detail') {
                queryCoverPic();
            }
            // $scope.getPreviewAccounts();
        }

        /**
         * [getTopUrl description] 取得封面图
         * @param   {[type]}  item   [item description]
         * @param   {[type]}  index  [index description]
         * @return  {[type]}         [return description]
         */
        $scope.getTopUrl = function(item, index) {
            if (!item.CoverPic) {
                return '';
            }
            return index === 0 ? item.CoverPic.TOPSRCPICURL : item.CoverPic.SRCPICURL;
        };

        /**
         * [findDocDetails description]群发历史获取稿件详情
         * @param  {[type]} items [description]
         * @return {[type]}       [description]
         */
        function findDocDetails(items) {
            var deferred = $q.defer();
            var params = {
                serviceid: 'mlf_wechatgroupsend',
                methodname: 'findDocDetails',
                DocIds: items.SENDINGORDER,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.massArray = data;
                deferred.resolve($scope.data.massArray);
            });
            return deferred.promise;
        }

        /**
         * [queryCoverPic description]获取封面图
         * @return {[type]} [description]
         */
        function queryCoverPic() {

            var params = {
                serviceid: 'mlf_wechatgroupsend',
                methodname: 'queryCoverPic',
                DocIds: trsspliceString.spliceString($scope.data.massArray, 'METADATAID', ','),
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                for (var i = 0; i < $scope.data.massArray.length; i++) {
                    for (var j = 0; j < data.length; j++) {
                        if ($scope.data.massArray[i].METADATAID === data[j].DOCID) {
                            $scope.data.massArray[i].CoverPic = data[j];
                        }
                    }
                }
            }, function() {
                $modalInstance.dismiss();
            });
        }

        /**
         * [sort description]排序
         * @return {[type]} [description]
         */
        $scope.sort = function() {
            $scope.status.isSort = true;
        };

        /**
         * [sort description]展示提示
         * @return {[type]} [description]
         */
        $scope.showTips = function() {
            $scope.status.showTipContent = true;
        };

        /**
         * [sort description]关闭提示
         * @return {[type]} [description]
         */
        $scope.hideTips = function() {
            $scope.status.showTipContent = false;
        };

        /**
         * [changeSort description]移动方法
         * @param  {[type]} flag  [description]
         * @param  {[type]} index [description]
         * @return {[type]}       [description]
         */
        $scope.changeSort = function(flag, index) {
            var indexItem;
            if (flag === 'down') {
                indexItem = $scope.data.massArray[index];
                $scope.data.massArray[index] = $scope.data.massArray[index + 1];
                $scope.data.massArray[index + 1] = indexItem;
            } else {
                indexItem = $scope.data.massArray[index];
                $scope.data.massArray[index] = $scope.data.massArray[index - 1];
                $scope.data.massArray[index - 1] = indexItem;
            }
        };

        /**
         * [return description]排序返回
         * @return {[type]} [description]
         */
        $scope.return = function() {
            $scope.status.isSort = false;
        };

        /**
         * [confirm description] 提交
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $scope.status.confirmOnce = true;
            if ($scope.data.accounts.length) {
                var params = {
                    serviceid: 'mlf_wechatgroupsend',
                    methodname: draftParams.methodname,
                    DocIds: '',
                    ToUser: trsspliceString.spliceString($scope.data.accounts, 'WXNAME', ','),
                    // ToUser: $scope.data.searchWord,
                };
                var arr = [];
                for (var i = 0; i < $scope.data.massArray.length; i++) {
                    arr.push($scope.data.massArray[i].METADATAID);
                }
                params.DocIds = arr.join();
                if ($scope.data.picWordId) { // 已预览下的预览弹框确认请求要加上这个id
                    params.WechatCardMessageId = $scope.data.picWordId;
                    params.methodname = 'previewCardAgain';
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', 'forbiden').then(function(data) {
                    wechatBtnService.wxPreviewSuccess(function() {
                        $scope.status.confirmOnce = false;
                        $modalInstance.close('success');
                    }, data, true, $scope.data.accounts);
                }, function(err) {
                    $scope.status.confirmOnce = false;
                    $modalInstance.close('success');
                    if (err.ISSUCCESS === 'false') {
                        wechatBtnService.wxPreviewSuccess(function() {
                        }, err, false);
                    }
                    if (err.status === '-1') {
                        modalDialog.alertType('', err.reason, 'warning', 'confirm', function() {
                        });
                    }
                });
            } else {
                modalDialog.alertType('请输入微信号', '', 'error', false, function() {
                    $scope.status.confirmOnce = false;
                });
            }
        };

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.close('fail');
        };
    },
]);
